import { getUrlParamRaw, decodeUrlQueryValue } from 'components/Dashboard/utilities/getUrlParam';

const changeSearchQuery = () => {
  let searchParam = getUrlParamRaw('search');
  let decodedQuery = decodeUrlQueryValue(searchParam);
  if (decodedQuery.trim().split(' ').length > 1 && !searchParam.includes('"')) {
    return `"${decodedQuery}"`;
  } else {
    return decodedQuery;
  }
};

export default changeSearchQuery;
